const ProfilePage = () => {
  return <div>This is a test for the profile page</div>;
};

export default ProfilePage;
